import {
    feedUpdateModel,
    feedUpdateImage
} from "../../../../actions/feed-actions"

import buildItemConnector from "../../../common/build-item-connector"

import EditFeedItemDetails from "./EditFeedItemDetails"

export default buildItemConnector(
    "feed",
    false,
    feedUpdateModel,
    feedUpdateImage,
    {},
    (presentation) => ({
        fulltext: presentation.fulltext,
        isFetchingFulltext: presentation.isFetchingFulltext
    })
)(EditFeedItemDetails)
